import "./stats-products.scss";

import { useTranslation } from "react-i18next";

import { StatsDashboardProducts } from "../orders-chart/interfaces";

const StatsProducts: React.FC<{ products: StatsDashboardProducts }> = ({
	products,
}) => {
	const { t } = useTranslation();

	return (
		<div className="stats-products">
			<div className="stats-products-best-sellers">
				<div className="stats-products-best-sellers-title">
					{t("stats-dashboard.products.best-sellers")}
				</div>
				<div className="stats-products-subtitle">
					<div>{t("stats-dashboard.products.product")}</div>
					<div>{t("stats-dashboard.products.units-sold")}</div>
				</div>
				<div className="stats-products-list">
					{products.best_sellers.map((product, index) => (
						<StatsProduct
							name={product.name}
							sku={product.sku}
							image={product.image}
							low_stock={product.low_stock}
							left_column={String(product.sales)}
							key={index}
						/>
					))}
				</div>
			</div>
			<div className="stats-products-oos">
				<div className="stats-products-oos-title">
					{t("stats-dashboard.products.oos")}
				</div>
				<div className="stats-products-subtitle">
					<div>{t("stats-dashboard.products.product")}</div>
					<div>{t("stats-dashboard.products.reason")}</div>
				</div>
				<div className="stats-products-list">
					{products.oos.map((product, index) => (
						<StatsProduct
							name={product.name}
							sku={product.sku}
							image={product.image}
							left_column={String(product.availability)}
							key={index}
						/>
					))}
				</div>
			</div>
		</div>
	);
};

export default StatsProducts;

const StatsProduct: React.FC<{
	name: string;
	sku: string;
	image: string;
	low_stock?: boolean;
	left_column: string;
}> = ({ name, sku, image, low_stock, left_column }) => {
	const { t } = useTranslation();

	const left =
		left_column == "no stock"
			? t("stats-dashboard.products.no-stock")
			: left_column == "disabled"
			? t("stats-dashboard.products.disabled")
			: left_column;

	return (
		<div className="stats-product">
			<div className="stats-product-right">
				<div className="stats-product-image">
					<img src={image} />
				</div>
				<div className="stats-product-info">
					<div className="stats-product-name">{name}</div>
					<div className="stats-product-sku">{sku}</div>
				</div>
			</div>

			<div className="stats-product-left">
				<div className="stats-product-left-column">{left}</div>
				{low_stock && (
					<div className="stats-product-low-stock">
						{t("stats-dashboard.products.low-stock")}
					</div>
				)}
			</div>
		</div>
	);
};
